module.exports = __webpack_public_path__ + "img/asds.f979679b.jpg";